<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="title"></a><a id="page_iii">WOMEN, WORK &amp; THE ART <em>of</em> SAVOIR FAIRE</a></h1><a id="page_iii">
<p class="bsubtitle"><em>Business Sense &amp; Sensibility</em></p>
<p class="image"><img alt="image" src="images/pub1.jpg"/></p>
<p class="bauthor"><span class="red">MIREILLE GUILIANO</span></p>
<p class="image"><img alt="image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm3_title.vue?9db46d1c